"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _joiBrowser = _interopRequireDefault(require("joi-browser"));

var _lodash = _interopRequireDefault(require("lodash"));

var _HttpService = _interopRequireDefault(require("../HttpService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ConditionsService = /*#__PURE__*/function () {
  function ConditionsService() {
    _classCallCheck(this, ConditionsService);
  }

  _createClass(ConditionsService, null, [{
    key: "isAddConditionRequestValid",

    /*
      Validation
    */
    value: function isAddConditionRequestValid(addConditionRequest) {
      if (addConditionRequest === null || addConditionRequest === undefined) {
        return false;
      }

      var schema = _joiBrowser["default"].object().keys({
        autoCompleteEventStatus: _joiBrowser["default"].number().integer().allow(null),
        collectionConditions: _joiBrowser["default"].array().items(_joiBrowser["default"].object().keys({
          collectionId: _joiBrowser["default"].number().integer().required(),
          comparingOperator: _joiBrowser["default"].string().required(),
          comparingValue: _joiBrowser["default"].number().required(),
          condition: _joiBrowser["default"].string().required(),
          timePeriod: _joiBrowser["default"].number().required()
        })).allow([]),
        conditionEventTemplate: _joiBrowser["default"].number().integer().allow(null),
        copyCollectionTagsToEvent: _joiBrowser["default"]["boolean"](),
        name: _joiBrowser["default"].string().min(2).max(100).required()
      });

      return _joiBrowser["default"].validate(addConditionRequest, schema).error === null;
    }
  }, {
    key: "isEditConditionRequestValid",
    value: function isEditConditionRequestValid(editConditionRequest) {
      if (editConditionRequest === null || editConditionRequest === undefined) {
        return false;
      }

      var schema = _joiBrowser["default"].object().keys({
        autoCompleteEventStatus: _joiBrowser["default"].number().integer().allow(null),
        collectionConditions: _joiBrowser["default"].array().items(_joiBrowser["default"].object().keys({
          collectionId: _joiBrowser["default"].number().integer().required(),
          comparingOperator: _joiBrowser["default"].string().required(),
          comparingValue: _joiBrowser["default"].number().required(),
          condition: _joiBrowser["default"].string().required(),
          timePeriod: _joiBrowser["default"].number().required()
        })).allow([]),
        conditionEventTemplate: _joiBrowser["default"].number().integer().allow(null),
        copyCollectionTagsToEvent: _joiBrowser["default"]["boolean"](),
        name: _joiBrowser["default"].string().min(2).max(100).allow(null)
      });

      return _joiBrowser["default"].validate(editConditionRequest, schema).error === null;
    }
    /*
      Service Methods
    */

  }, {
    key: "getConditions",
    value: function getConditions(pagination) {
      var url = "?page=".concat(pagination.page, "&size=").concat(pagination.size, "&search=").concat(pagination.search);

      _lodash["default"].forEach(pagination.sort, function (value) {
        url = url.concat("&sort=".concat(value));
      });

      return this.httpService.get(url);
    }
  }, {
    key: "getConditionEventsForCondition",
    value: function getConditionEventsForCondition(conditionId, pagination) {
      var url = "/".concat(conditionId, "/conditionEvents?page=").concat(pagination.page, "&size=").concat(pagination.size);

      _lodash["default"].forEach(pagination.sort, function (value) {
        url = url.concat("&sort=".concat(value));
      });

      return this.httpService.get(url);
    }
  }, {
    key: "addCondition",
    value: function addCondition(addConditionRequest) {
      var _this = this;

      if (!ConditionsService.isAddConditionRequestValid(addConditionRequest)) {
        return Promise.reject(new Error('Invalid add condition request'));
      }

      return new Promise(function (resolve, reject) {
        _this.httpService.post('/', addConditionRequest).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "editCondition",
    value: function editCondition(conditionId, editConditionRequest) {
      var _this2 = this;

      if (!Number.isInteger(conditionId)) {
        return Promise.reject(new Error('Missing Condition ID'));
      }

      if (!ConditionsService.isEditConditionRequestValid(editConditionRequest)) {
        return Promise.reject(new Error('Invalid edit condition request'));
      }

      return new Promise(function (resolve, reject) {
        _this2.httpService.patch("/".concat(conditionId), editConditionRequest).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "deleteCondition",
    value: function deleteCondition(conditionId) {
      var _this3 = this;

      if (!Number.isInteger(conditionId)) {
        return Promise.reject(new Error('Missing Condition ID'));
      }

      return new Promise(function (resolve, reject) {
        _this3.httpService["delete"]("/".concat(conditionId)).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }]);

  return ConditionsService;
}();

exports["default"] = ConditionsService;
ConditionsService.httpService = new _HttpService["default"]({
  baseURL: "".concat(typeof window !== 'undefined' ? env.REACT_APP_DATAPOINT_METADATA_API : '', "/conditions")
});